<script setup lang="ts">
import type { WatermarkMode } from "./useBatchEditSession"

const props = defineProps<{ modelValue: WatermarkMode }>()
const emit = defineEmits<{ "update:modelValue": [value: WatermarkMode] }>()

const options: Array<{ value: WatermarkMode; label: string }> = [
  { value: "noop", label: "Nicht ändern" },
  { value: "on", label: "Ein" },
  { value: "off", label: "Aus" }
]

function select(value: WatermarkMode): void {
  if (props.modelValue === value) return
  emit("update:modelValue", value)
}

function onArrowKey(direction: number): void {
  const index = options.findIndex(o => o.value === props.modelValue)
  const next = options[(index + direction + options.length) % options.length]!
  emit("update:modelValue", next.value)
}
</script>

<template>
  <div class="join" role="radiogroup" aria-label="Watermark">
    <button
      v-for="opt of options"
      :key="opt.value"
      type="button"
      role="radio"
      class="btn btn-sm join-item"
      :class="{ 'btn-primary': modelValue === opt.value }"
      :aria-checked="modelValue === opt.value"
      :tabindex="modelValue === opt.value ? 0 : -1"
      @click="select(opt.value)"
      @keydown.left.prevent="onArrowKey(-1)"
      @keydown.right.prevent="onArrowKey(1)"
    >
      {{ opt.label }}
    </button>
  </div>
</template>
